export const ANNOTATION_FOCUS_FALLBACK_ATTRIBUTE = 'data-annotation-focus-fallback';

/** Marks a surface's annotation toggle: where focus goes once the control holding it is gone. */
export const ANNOTATION_FOCUS_FALLBACK_PROPS = {[ANNOTATION_FOCUS_FALLBACK_ATTRIBUTE]: ''} as const;

export function focusAnnotationFallbackIfLost(): void {
  if (!document.activeElement || document.activeElement === document.body) {
    document.querySelector<HTMLElement>(`[${ANNOTATION_FOCUS_FALLBACK_ATTRIBUTE}]`)?.focus();
  }
}

/** What the browser stops on with Tab. */
export const TABBABLE_SELECTOR =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex^="-"])';

/**
 * Moves focus to the tab stop in `container` after the focused element, or before it,
 * wrapping at either end, so Tab never leaves it.
 */
export const moveTabWithin = (container: HTMLElement, backward: boolean): void => {
  const stops = Array.from(container.querySelectorAll<HTMLElement>(TABBABLE_SELECTOR));
  const focused = document.activeElement;
  const isAfterFocused = (stop: HTMLElement): boolean =>
    !focused || Boolean(focused.compareDocumentPosition(stop) & Node.DOCUMENT_POSITION_FOLLOWING);
  const target = backward
    ? (stops.filter((stop) => stop !== focused && !isAfterFocused(stop)).at(-1) ?? stops.at(-1))
    : (stops.find(isAfterFocused) ?? stops[0]);
  target?.focus();
};
